exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-f8958ab6] {\n  height: 42px !important;\n  border-radius: 4px !important;\n}\n.mb-10[data-v-f8958ab6] {\n  margin-bottom: 10px !important;\n}\n.mt-10[data-v-f8958ab6] {\n  margin-top: 10px !important;\n}\n.select[data-v-f8958ab6] {\n  width: 100% !important;\n}\nh4[data-v-f8958ab6] {\n  font-weight: bold !important;\n}\n.grid-title[data-v-f8958ab6] {\n  border-top: 1px solid #eee;\n}\n", ""]);

// exports
